
import { useNavigate, useParams } from "react-router-dom";
import AddMovieHeader from "../components/AddMovieHeader";
import SeasonCard from "./Season/SeasonCard";
import EpisodeTable from "./Season/Episodes";
import BasicInformation from './Season/BasicInformation'
import StatusBanner from "components/StatusBanner";
import useSWR from "swr";

export default function Season({ onCancel, details }) {



  const { seasonId, movieId } = useParams()

  const { data: movieDetailsData } = useSWR(`/entertainment/movie-box/medias/${movieId}`)
  const movieDetails = movieDetailsData?.data
  const { data: seasonData } = useSWR(`/entertainment/movie-box/medias/${movieId}/seasons/${seasonId}`)
  const season = seasonData?.data
  const baseMovie = movieDetails ?? details

  const navigate = useNavigate();
  const handleCancel = () => {
    if (typeof onCancel === "function") onCancel();
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <AddMovieHeader
        onCancel={handleCancel}
        showProgress={true}
        currentStep={1}
        title={season?.tv_show?.title || ''}
      />
      <main className="py-4 px-10 w-full md:w-[85%] mx-auto">
        <StatusBanner status={season?.status?.toLowerCase() || "unpublished"} />
        <div className="flex-1 flex justify-center mt-5 gap-4 md:h-[calc(100vh-200px)]">
          <div className="w-full md:w-[30%] overflow-y-auto rounded">
            <SeasonCard
              image={season?.poster || season?.backdrop || '/img/cover_pic.jpg'}
              title={season?.tv_show?.title || ''}
              subtitle={season?.tag_line || season?.description || ''}
              season={`Season ${season?.number ??  details?.seasons?.length+1 }`}
              released={baseMovie?.release_year || '-'}
              country={baseMovie?.country?.name || '-'}
              language={baseMovie?.language?.name || '-'}
              type={'TV Series'}
              categories={baseMovie?.genres || []}
              classifications={baseMovie?.classifications || []}
              onEdit={() => alert("Edit clicked")}
              onMoreDetail={() => alert("More detail clicked")}
            />
          </div>
          <div className="w-full md:w-[70%] overflow-y-auto rounded">

            {
              // //  {/* Basic information (view/edit) */} 
              // (!seasonId || details)? <div className="mb-6">
              //   <BasicInformation defaultMode={'view'} season={season} />
              // </div>
              //   :
              //   // {/* Episodes table */}
                <EpisodeTable movieId={movieId} season={season} episodes={season?.episodes || []} />
            }

          </div>
        </div>
      </main>
    </div>
  );
}
